import { ROLES, USER_STATUSES } from "models";

export const useGetFilterOptions = () => {
  const roleOptions = [
    { key: ROLES.SuperAdmin, value: ROLES.SuperAdmin, text: "Super Admin" },
    { key: ROLES.Importer, value: ROLES.Importer, text: "Importer" }
  ];

  const statusOptions = [
    { key: USER_STATUSES.Active, value: USER_STATUSES.Active, text: "Active" },
    { key: USER_STATUSES.Inactive, value: USER_STATUSES.Inactive, text: "Inactive" }
  ];

  const roleOptionsWithAll = [{ key: "all", value: 0, text: "All" }, ...roleOptions];
  const statusOptionsWithAll = [{ key: "all", value: 0, text: "All" }, ...statusOptions];

  return { roleOptions, statusOptions, roleOptionsWithAll, statusOptionsWithAll };
};

export const useGetRoleTranslations = () => {
  return [
    { role: ROLES.SuperAdmin, translation: "Super Admin" },
    { role: ROLES.Importer, translation: "Importer" }
  ];
};
